// extracted by mini-css-extract-plugin
export var cronos = "CronosPro, Helvetica, Arial, sans-serif";
export var eason = "EasonPro, \"Times New Roman\", serif";
export var easonCaps = "EasonProDisplayCaps, EasonPro, \"Times New Roman\", serif";
export var intro = "intro-module--intro--i5mg+";
export var introCopy = "intro-module--introCopy--kIJh+";
export var red1 = "rgb(245, 13, 27)";
export var title = "intro-module--title--9TLn1";